import { connect } from 'react-redux';
import NewProject from './NewProject';

import { selectTotalkWh, selectTotalFixed } from '../common/utility/selectors';
import { createProject } from './actions';


const mapStateToProps = state => ({
    isVisible: state.createUI.isVisible,
    isLocked: state.isLockedUI.isLocked,
    projects: state.projects,
    selectedState: state.clientInfoUI.selectedState,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    phone: state.contactUI.phone,
    position: state.contactUI.position,
    email: state.contactUI.email,
    esskW: state.ess.esskW,
    essPrice: state.ess.essPrice,
    esskWh: state.ess.esskWh,
    madeInCA: state.ess.madeInCA,
    includeESS: state.ess.includeESS,
    loanTerm: state.loan.loanTerm,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    mosaicTerm: state.loan.mosaicTerm,
    mosaicDownPayment: state.loan.mosaicDownPayment,
    loanProvider: state.loan.loanProvider,
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    sgipValue: state.sgip.sgipValue,
    sgipToggle: state.sgip.sgipToggle,
    productionRatio: state.solar.productionRatio,
    solarValue: state.solar.solarValue,
    installType: state.solar.installType,
    installType2: state.solar.installType2,
    energyValue: state.utility.energyValue,
    utility: state.solarInputsUI.utility,
    annualDeg: state.solar.annualDeg,
    solarInputsToggle: state.solarInputsUI.solarInputsToggle,
    cashprice: state.solar.cashprice,
    installYear: state.tax.installYear,
    taxRate: state.tax.taxRate,
    taxEntity: state.tax.taxEntity,
    annualInflation: state.utility.annualInflation,
    provider: state.utility.provider,
    annualMonth: state.settings.annualMonth,
    totalkWhs: selectTotalkWh(state),
    totalFixed: selectTotalFixed(state),
    aFixedCharge: state.utility.aFixedCharge,
    annualKWH: state.utility.annualKWH,
    mFixedCharge: state.utility.mFixedCharge,
    monthlyKWh: state.utility.monthlyKWh,
    createProject,
    showPPA: state.ppa.showPPA,
    showLoan: state.loan.showLoan,
    showOBS: state.obs.showOBS,
    obsTerm: state.obs.obsTerm,
    obsDownPayment: state.obs.obsDownPayment,
    obsCredit: state.obs.obsCredit,
    systemSize: state.solar.systemSize,
    horizonLength: state.settings.horizonLength,
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    resiToggle: state.tax.resiToggle,
    projectZip: state.projectaddress.projectZip,
    projectStreet: state.projectaddress.projectStreet,
    projectStreet2: state.projectaddress.projectStreet2,
    projectName: state.projectaddress.projectName,
    projectState: state.projectaddress.projectState,
    projectCity: state.projectaddress.projectCity,
    projectCountry: state.projectaddress.projectCountry,
    showCAP: state.cap.showCAP,
    capTerm: state.cap.capTerm,
    capDownPayment: state.cap.capDownPayment,
    includeCash: state.cash.includeCash,
    nyRebate: state.nyserda.nyRebate,
    inverter: state.solar.inverter,
    solarPanel: state.solar.solarPanel,
    batteryType: state.ess.batteryType,
    systemNotes: state.solar.systemNotes,
    authToken: state.auth.authToken,
    soldStatus: state.projectstatus.soldStatus,
    archiveStatus: state.projectstatus.archiveStatus,
    jobStatus: state.projectstatus.jobStatus,
    createProjectErr: state.createUI.createProjectErr,
    clientId: state.addClientUI.clientId,
    smartValue: state.smart.smartValue,
});

const mapDispatchToProps = dispatch => ({
    createProject: (authToken, project) => dispatch(createProject(authToken, project)),
});


export default connect(mapStateToProps, mapDispatchToProps)(NewProject);



// WEBPACK FOOTER //
// ./src/containers/NewProject/index.js